// Func = limiting Scope for this file
var lastScrollTop = 0;

function hideElement(e){
	let elem = document.querySelector( e ).parentElement
	elem.classList.add("hidden");
	elem.style.position = "absolute"
}

function showElement(e){
	let elem = document.querySelector( e ).parentElement
	elem.classList.remove("hidden");
	elem.style.position = "relative"
}

(function(){

	hideElement("#email-signup_state_us");
	hideElement("#email-signup_state_canadian");

	let email_signup_country = document.querySelector( "#email-signup_country" );
	email_signup_country.addEventListener( "change", (e) => {
		if( e.target.value == "US" ){
			showElement("#email-signup_state_us")
			hideElement("#email-signup_state_canadian")
			hideElement("#email-signup_state_other")
		}	
		if( e.target.value == "CA" ){
			showElement("#email-signup_state_canadian")
			hideElement("#email-signup_state_us")
			hideElement("#email-signup_state_other")
		}	
		if( e.target.value != "US" && e.target.value != "CA" ){
			showElement("#email-signup_state_other")
			hideElement("#email-signup_state_us")
			hideElement("#email-signup_state_canadian")
		}
	} );

	$(document).ready(function () {

		const primNavItems = document.querySelectorAll('.primary-main');
		const allSubNavs = document.querySelectorAll('.privary-navigation__submenu');
		const allSubLinks = document.querySelectorAll('.submenu-link');

		for(const item of primNavItems) {
			const subNav = item.nextElementSibling;

			item.addEventListener('click', function() {
                if(item.classList.contains('active')) {
                    item.parentElement.classList.remove('active');
					subNav.classList.remove('open');
                } else {
                    primNavItems.forEach(el => {
                        el.parentElement.classList.remove('active');
                    });
					allSubNavs.forEach(el => {
                        el.classList.remove('open');
                    });
                    subNav.classList.add('open');
					item.parentElement.classList.add('active');
                }
            });
			if(subNav) {
				subNav.classList.add('main-submenu');
			}
		};

		for(const item of allSubLinks) {
			const subNav = item.nextElementSibling;

			item.addEventListener('click', function(e) {
				e.preventDefault();
				subNav.classList.add('open');
			});
		};

		// Main Nav

		$('.js-booking-trigger').click(function(e) {
			e.preventDefault();
		    $('#booking').toggleClass('open');
			$(document.body).addClass('pause-scroll');
		});

		$('.js-menu-trigger').click(function(e) {
			e.preventDefault();
		    $('.main-menu').toggleClass('open');
			$(document.body).addClass('pause-scroll');
		});

		$('.js-close-menu').click(function() {
		    $('.main-menu').toggleClass('open');
			$(document.body).removeClass('pause-scroll');
		});

		$('.js-close-booking').click(function() {
		    $('#booking').toggleClass('open');
			$(document.body).removeClass('pause-scroll');
		});

		$('.fancybox').fancybox();

		$('[data-slick-goto]').click(function () {
			const $curSlider = $(this).data('slick-target') ? $($(this).data('slick-target')) : $(this).closest('.sym-slides');
			const target = $(this).data('slick-goto') ? parseInt($(this).data('slick-goto')) : 0;
	
			$curSlider.slick('slickGoTo', target);
			$(this).siblings('[data-slick-goto]').removeClass('js-slick_active active');
			$(this).addClass('js-slick_active active');
		});

		$('.gallery-slider-center').slick({
			accessibility: true,
			fade:true,
			dots:false,
			arrows:true,
			speed:600 ,
			asNavFor:'.gallery-slider',
			responsive: [
				{
				  breakpoint: 600,
				  settings: {
					arrows: true
				  }
				},
			]
		});
	
		$('.gallery-slider-sides').slick({
			accessibility: true,
			fade:true,
			dots:false,
			arrows:false,
			speed:600 ,
			asNavFor:'.gallery-slider'
		});
	
	
		$('.gallery-slider').slick({
			arrows: false,
			dots: true,
			fade: true,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						dots: false,
						fade: false,
						variableWidth: true,
						slidesToShow: 1,
						centerMode: true,
					}
				}
			]
		});

		if($('#form_id-260').length!=0){
			$( ".arrival-dp input" ).datepicker( "destroy" );
			$( ".arrival-dp input" ).datepicker({
				minDate: 0, 
				onSelect: function( selectedDate ) {
					$( ".departure-dp input" ).datepicker("option", "minDate", selectedDate );
					setTimeout(function(){
						$( ".departure-dp input" ).datepicker('show');
					}, 16);     
				}
			});
		}
		if($('#form_id-261').length!=0){
			$( "input[name=arrival_date" ).datepicker( "destroy" );
			$( "input[name=arrival_date]" ).datepicker({
				minDate: 0, 
				onSelect: function( selectedDate ) {
					$( "input[name=departure_date]" ).datepicker("option", "minDate", selectedDate );
					setTimeout(function(){
						$( "input[name=departure_date]" ).datepicker('show');
					}, 16);     
				}
			});
		}

		$('.select-2').select2();
	
	});

	window.onload = function() {
		scrollW();
		setInterval(displayTime, 1000);
		window.addEventListener('scroll', function(){
			scrollW();
		});
	};

}());

const localTime = document.getElementById("js-local-time");

function displayTime(){

	let today = new Date();
	let hour = today.getHours();
	let minute = today.getMinutes();
	let seconds = today.getSeconds();

	hour = (hour < 10) ? "0" + hour : hour;
	minute = (minute < 10) ? "0" + minute : minute;
	seconds = (seconds < 10) ? "0" + seconds : seconds;

	let time = hour + ":" + minute ;
	if(localTime) {
		localTime.innerText = time;
		localTime.textContent = time;
	}

}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let logo = document.querySelector('.js-scroll-logo');
	const header = document.getElementById('header');
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!header.classList.contains('down')){
				header.classList.add('down');
				header.classList.remove('up');
			}
			if(!header.classList.contains('scroll')){
				header.classList.add('scroll');
			
				if(logo) {
					changeSrc(logo.getElementsByTagName('img')[0]);
				}
			
			};

		} else {
			// upscroll code
			if(!header.classList.contains('up')){
				header.classList.add('up');
				header.classList.remove('down');
			}
		}
	} else {
		if(header.classList.contains('up') || header.classList.contains('down')) {
			header.classList.remove('up');
			header.classList.remove('down');
		}
		if(header.classList.contains('scroll')) {
			header.classList.remove('scroll');
			if(logo) {
				changeSrc(logo.getElementsByTagName('img')[0]);
			}
		}

	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}

//MOBILE SEARCH FORM OPEN FUNCTION
if (window.innerWidth < 1000) {

	const searchFilter = document.getElementById("filters");
	const ctaFilter = document.getElementById("js-mobile-filter");

	function toggleFilter() {
	
		ctaFilter.classList.toggle("open");
		searchFilter.classList.toggle("open");

		if (ctaFilter.classList.contains("open")) {
			ctaFilter.innerHTML = "close search";
		} else {
			ctaFilter.innerHTML = "refine your search";
		}
	}
	if (ctaFilter) {
		ctaFilter.addEventListener("click", toggleFilter);
	}
};

function submenu(){
	var submenuHold = document.querySelectorAll('.sub-menu__hold:not(.subMenu_mobile)');
	var allsublinks = document.querySelectorAll('.sub-menu__hold:not(.subMenu_mobile) .sub-menu a');
	if(allsublinks.length > 1){
		allsublinks.forEach(ele=>{
			ele.addEventListener('click', function(ev){
				if(ele.classList.contains('active')){
					ev.preventDefault();
				}
			});
		});
		var toggleBtn = document.querySelector('.sub-menu__toggle');
		if(toggleBtn){
			toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
			toggleBtn.addEventListener('click', function(){
				toggleBtn.parentElement.classList.toggle('open');
			});
		}
	}else if(submenuHold.length > 0){
		submenuHold[0].classList.add('no-sub');
	}
	
}
submenu();


document.addEventListener('DOMContentLoaded', (event) => {
	let menuSubMobile = document.querySelector('.subMenu_mobile');

	if( menuSubMobile ){
		menuSubMobile.addEventListener('click', (e) => {
			if(e.target.nodeName == 'A' && menuSubMobile.querySelector('.sub-menu > ul > li > ul')){
				e.preventDefault();
				let subMenu_inside_subMenu = menuSubMobile.querySelector('.sub-menu > ul > li > ul');
				menuSubMobile.querySelector('.sub-menu > ul > li > ul').style.display = "flex";
				menuSubMobile.querySelector('.submenushowed').appendChild(subMenu_inside_subMenu);
				
				e.target.classList.add('with_subMenu');
			}else if(e.target.classList.contains('with_subMenu')){
				e.preventDefault();
				e.target.parentElement.appendChild(menuSubMobile.querySelector('.submenushowed > ul'));
				e.target.classList.remove('with_subMenu');
				menuSubMobile.querySelector('.sub-menu > ul > li > ul').style.display = "none";
			}
		})
	}

	/********************************************************
	* ?Validation for the inputs that contains only numbers *
	********************************************************/

	const FOMRS_TO_CHECK = document.querySelectorAll('form.form-module[id^="form_id-"]');
	FOMRS_TO_CHECK.forEach( form => {
		let inputs_number = form.querySelectorAll('input[name*="number"]');
		if( inputs_number ){
			inputs_number.forEach( input => {
				input.addEventListener( 'keyup', (event) => {
					if (!event.key.match(/[0-9]/) && !event.key.match(/[+]/)) {
						input.value = input.value.substring(-1, (input.value.length -1 ));
					}		
				} )
			} );
		}
	} )

});